import $ from 'jquery';

export default function awardSliderGroup() {
    var previous = $().isWelshPage() ? 'Blaenorol' : 'Previous',
        next     = $().isWelshPage() ? 'Nesaf' : 'Next';

    $('.award-slider-group').slick({
        prevArrow: `<button class="slick-prev" aria-label="${previous}" type="button">${previous}</button>`,
        nextArrow: `<button class="slick-next" aria-label="${next}" type="button">${next}</button>`,
        infinite: true,
        speed: 100,
        dots: true,
        mobileFirst: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    centerMode: true
                }
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    centerMode: false
                }
            },
            {
                breakpoint: 1100,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    centerMode: true
                }
            }
        ]
    });
}
